// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TileList_wrapper___rpj0"};